import React, { useEffect, useState } from "react";
import { getBankBookReport } from "../services/reports.services";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import moment from "moment";
import {
  checkAcessRights,
  formatIndianNumber,
  formatIndianNumberWithCRANDDR,
} from "../../../_helper/helper";
import { Button } from "@progress/kendo-react-buttons";
import { PRINT_ACCESS } from "../../../_contstants/common";

const BankBookReport: React.FC = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const ledger_id = params.ledger_id;
  const from_date = params.from_date;
  const to_date = params.to_date;

  const isPrintAccess = checkAcessRights("/bankbookreport", PRINT_ACCESS);

  const BankBookPrintDetails = useAppSelector(
    (state) => state.reports.BankBookPrintDetails
  );

  const [updatedTransactions, setUpdatedTransactions] = useState<any[]>([]);
  const [totalDebitAmount, setTotalDebitAmount] = useState<number>(0);
  const [totalCreditAmount, setTotalCreditAmount] = useState<number>(0);

  useEffect(() => {
    if (
      !BankBookPrintDetails?.lstBankBook ||
      BankBookPrintDetails?.lstBankBook.length === 0
    ) {
      return;
    }

    let balance =
      BankBookPrintDetails?.BalanceType === "CR"
        ? BankBookPrintDetails?.OpeningBalance
        : -BankBookPrintDetails?.OpeningBalance;

    let totalDebit =
      BankBookPrintDetails?.BalanceType === "DR"
        ? BankBookPrintDetails?.OpeningBalance
        : 0;
    let totalCredit =
      BankBookPrintDetails?.BalanceType === "CR"
        ? BankBookPrintDetails?.OpeningBalance
        : 0;

    const updatedData = BankBookPrintDetails.lstBankBook.map((txn: any) => {
      balance += txn.CreditAmount;
      balance -= txn.DebitAmount;

      totalDebit += txn.DebitAmount;
      totalCredit += txn.CreditAmount;

      return { ...txn, ClosingBalance: balance };
    });

    setUpdatedTransactions(updatedData);
    setTotalDebitAmount(totalDebit);
    setTotalCreditAmount(totalCredit);
  }, [BankBookPrintDetails?.lstBankBook]);

  useEffect(() => {
    const payload = {
      ledger_id: ledger_id !== "0" ? ledger_id : null,
      from_date: from_date ? from_date : null,
      to_date: to_date ? to_date : null,
    };
    dispatch(getBankBookReport(payload));
  }, []);

  return (
    <div>
      <div className="position-relative no-visible-print-btn text-end p-2">
        {isPrintAccess && (
          <Button
            style={{ marginRight: 5 }}
            type="button"
            fillMode={"solid"}
            themeColor={"primary"}
            onClick={() => window.print()}
          >
            Print
          </Button>
        )}
      </div>
      <div className="container-fluid bankbook-report">
        <div>
          <p className="text-center">
            <b>Harihar Foods Pvt.Ltd. 2021-2022</b>
            <br />
            519/1, Nr Ramol Police Chowky
            <br />
            Phase IV,. G.I.D.C., Vatva, Ahmedabad 382445
            <br />
            Tel (Off) 079-25841773 / 25840855
            <br />
            FSSAI NO : 10012021000359
            <br />
            CIN: U15499GJ1994PTC021520
            <br />
            E-Mail : marketing@shreeganeshmasala.com
            <br />
          </p>
        </div>
        <div>
          <p className="text-center">
            <b>{BankBookPrintDetails?.AccountName}</b>
            <br />
            {BankBookPrintDetails?.Address}
          </p>
        </div>
        <div>
          <p className="text-center">
            {` ${
              from_date
                ? moment(from_date, "YYYY-MM-DD")?.format("DD-MMM-YYYY")
                : ""
            } to ${
              to_date
                ? moment(to_date, "YYYY-MM-DD")?.format("DD-MMM-YYYY")
                : ""
            }`}
          </p>
        </div>
        <table className="w-100">
          <thead
            style={{
              borderTop: "1px solid black",
              borderBottom: "1px solid black",
            }}
          >
            <tr>
              <th style={{ width: "10%", textAlign: "center" }}>Date</th>
              <th style={{ width: "33%" }}>Particulars</th>
              <th style={{ width: "10%", textAlign: "center" }}>Vch Type</th>
              <th style={{ width: "10%", textAlign: "center" }}>Vch No.</th>
              <th style={{ width: "11%", textAlign: "center" }}>Debit</th>
              <th style={{ width: "11%", textAlign: "center" }}>Credit</th>
              <th style={{ width: "15%", textAlign: "center" }}>
                Closing Balance
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="padding-5 pb-10">
                {from_date
                  ? moment(from_date, "YYYY-MM-DD")?.format("DD/MM/YYYY")
                  : ""}
              </td>
              <td className="padding-5 pb-10 fw-600">Opening Balance</td>
              <td className="padding-5 pb-10"></td>
              <td className="padding-5 pb-10"></td>
              <td className="text-end padding-5 pb-10">
                {BankBookPrintDetails?.BalanceType === "DR" &&
                  formatIndianNumber(BankBookPrintDetails?.OpeningBalance)}
              </td>
              <td className="text-end padding-5 pb-10">
                {BankBookPrintDetails?.BalanceType === "CR" &&
                  formatIndianNumber(BankBookPrintDetails?.OpeningBalance)}
              </td>
              <td className="text-end padding-5 pb-10">
                {formatIndianNumberWithCRANDDR(
                  BankBookPrintDetails?.BalanceType === "CR"
                    ? BankBookPrintDetails?.OpeningBalance
                    : -BankBookPrintDetails?.OpeningBalance || "0"
                )}
              </td>
            </tr>
            <tr>
              <td colSpan={7}>
                <hr className="m-1" />
              </td>
            </tr>
            {updatedTransactions?.map((data: any, index: number) => {
              return (
                <>
                  <tr key={index}>
                    <td
                      className="padding-5 pb-10"
                      rowSpan={data?.BankBookDetails?.length > 1 ? 2 : 1}
                    >
                      {data?.VoucherDate}
                    </td>
                    <td className="padding-5 pb-0">
                      {data?.DebitAmount > 0
                        ? "Cr "
                        : data?.CreditAmount > 0
                        ? "Dr "
                        : ""}
                      <span style={{ fontWeight: 600 }}>
                        {data?.BankBookDetails &&
                        data?.BankBookDetails?.length > 1
                          ? "(as per details)"
                          : data?.BankBookDetails[0]?.AccountName}
                      </span>
                    </td>
                    <td
                      className="padding-5 pb-10"
                      // rowSpan={data?.BankBookDetails?.length > 1 ? 2 : 1}
                    >
                      {data?.VoucherType}
                    </td>
                    <td
                      className="padding-5 pb-10"
                      // rowSpan={data?.BankBookDetails?.length > 1 ? 2 : 1}
                    >
                      {data?.VoucherNo}
                    </td>
                    <td
                      className="text-end padding-5 pb-10"
                      rowSpan={data?.BankBookDetails?.length > 1 ? 2 : 1}
                    >
                      {data?.DebitAmount && data?.DebitAmount > 0
                        ? formatIndianNumber(data?.DebitAmount)
                        : ""}
                    </td>
                    <td
                      className="text-end padding-5 pb-10"
                      rowSpan={data?.BankBookDetails?.length > 1 ? 2 : 1}
                    >
                      {data?.CreditAmount && data?.CreditAmount > 0
                        ? formatIndianNumber(data?.CreditAmount)
                        : ""}
                    </td>
                    <td
                      className="text-end padding-5 pb-10"
                      rowSpan={data?.BankBookDetails?.length > 1 ? 2 : 1}
                    >
                      {formatIndianNumberWithCRANDDR(data?.ClosingBalance)}
                    </td>
                  </tr>
                  {data?.BankBookDetails &&
                    data?.BankBookDetails?.length > 1 && (
                      <tr>
                        <td colSpan={3}>
                          <table className="w-100 fw-600">
                            {data?.BankBookDetails?.map((name: any) => {
                              return (
                                <tr>
                                  <td style={{ width: "40%" }}>
                                    {name?.AccountName}
                                  </td>
                                  <td
                                    style={{ width: "25%" }}
                                    className="text-end"
                                  >
                                    {name?.CreditAmount > 0
                                      ? `${formatIndianNumber(
                                          name?.CreditAmount
                                        )} Cr`
                                      : name?.DebitAmount > 0
                                      ? `${formatIndianNumber(
                                          name?.DebitAmount
                                        )} Dr`
                                      : ""}
                                  </td>
                                  <td style={{ width: "2%" }}></td>
                                  <td style={{ width: "13%" }}>Cheque</td>
                                  <td style={{ width: "20%" }}>
                                    {name?.ChequeNo}
                                  </td>
                                </tr>
                              );
                            })}
                          </table>
                          {/* <table className="w-100">
                            {data?.BankBookDetails?.map((name: any) => {
                              return (
                                <tr>
                                  <td>Cheque</td>
                                  <td>{name?.ChequeNo}</td>
                                  <td className="text-end">
                                    {name?.CreditAmount > 0
                                      ? `${formatIndianNumber(
                                          name?.CreditAmount
                                        )} Cr`
                                      : name?.DebitAmount > 0
                                      ? `${formatIndianNumber(
                                          name?.DebitAmount
                                        )} Dr`
                                      : ""}
                                  </td>
                                </tr>
                              );
                            })}
                          </table> */}
                        </td>
                      </tr>
                    )}
                  <tr>
                    <td colSpan={7}>
                      <hr className="m-1" />
                    </td>
                  </tr>
                </>
              );
            })}
            <tr>
              <td className="padding-5 "></td>
              <td className="padding-5  fw-600">Closing Balance</td>
              <td className="padding-5 "></td>
              <td className="padding-5 "></td>
              <td
                className="text-end padding-5 "
                style={{
                  borderTop: "1px solid black",
                }}
              >
                {formatIndianNumber(totalDebitAmount)}
              </td>
              <td
                className="text-end padding-5 "
                style={{
                  borderTop: "1px solid black",
                }}
              >
                {formatIndianNumber(totalCreditAmount)}
              </td>
              <td
                style={{
                  borderTop: "1px solid black",
                }}
                className="padding-5 "
              ></td>
            </tr>
            <tr>
              <td colSpan={4}></td>
              <td className="text-end padding-5">
                {totalCreditAmount > totalDebitAmount
                  ? formatIndianNumber(totalCreditAmount - totalDebitAmount)
                  : ""}
              </td>
              <td className="text-end padding-5">
                {totalDebitAmount > totalCreditAmount
                  ? formatIndianNumber(totalDebitAmount - totalCreditAmount)
                  : ""}
              </td>
              <td className="padding-5"></td>
            </tr>
            <tr>
              <td colSpan={4}></td>
              <td
                className="text-end padding-5"
                style={{
                  borderTop: "1px solid black",
                  borderBottom: "1px solid black",
                }}
              >
                {totalDebitAmount > totalCreditAmount
                  ? formatIndianNumber(totalDebitAmount)
                  : formatIndianNumber(totalCreditAmount)}
              </td>
              <td
                className="text-end padding-5"
                style={{
                  borderTop: "1px solid black",
                  borderBottom: "1px solid black",
                }}
              >
                {totalDebitAmount > totalCreditAmount
                  ? formatIndianNumber(totalDebitAmount)
                  : formatIndianNumber(totalCreditAmount)}
              </td>
              <td
                style={{
                  borderTop: "1px solid black",
                  borderBottom: "1px solid black",
                }}
                className="padding-5 "
              ></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BankBookReport;
